<template>
    <div>
        <!-- TOAST PARA LOS MENSAJES -->
        <div class="p-d-flex">
            <Toast />
        </div>
        
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>

        <!-- NUEVA NOMINA -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogNuevaNomina" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <NuevaNomina @closeDialogNuevaNomina="dialogNuevaNomina = false"></NuevaNomina>
        </Dialog>

        <!-- NOMINA GUARDADA -->
        <Dialog :showHeader="false" position="top" :visible.sync="dialogNominaGuardada" :closeOnEscape="true"
        :closable="false" :modal="false" :style="{ width: '95vw' }" class="border-round">
            <NominaGuardada @closeDialogNuevaNomina="dialogNominaGuardada = false"></NominaGuardada>
        </Dialog>

        <!-- BORRAR NOMINA -->
        <Dialog header="Eliminar" :visible.sync="dialogDelete" :containerStyle="{width: '350px'}" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span>Desea eliminar la nomina {{ selectedNomina.descripcion }}?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" @click="dialogDelete = false" class="p-button-text"/>
                <Button label="Sí" icon="pi pi-check" @click="DeleteNomina" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- LISTA DE NOMINAS -->
        <DataTable :value="listaNominas" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" >
            <template #header>
                <div class="text-left p-d-flex justify-center p-fluid grid formgrid">
                    <div class="col-5 text-left pa-0 ma-0 pl-3">
                        <div class="flex align-items-left justify-content-left w-14rem h-4rem m-2">
                            <h1>Nóminas</h1>
                            <ProgressSpinner v-if="spinnerT" style="width:36px;height:36px;  vertical-align: middle;"
                              strokeWidth="8" fill="#ff6699" animationDuration=".5s" />
                            <Button v-if="!spinnerT" :label="timbresDisponibles" class="p-button-rounded w-4rem h-2rem ml-2" style="color:#ffffff" @click="getTimbres()"/>
                        </div>
                    </div>
                    <div class="col-6 text-right">
                        <div class="text-left p-d-flex justify-center p-fluid grid formgrid">
                          <div class="col-12 md:col-6 text-left">
                            <span class="p-float-label">
                              <Calendar v-model="fechaI" dateFormat="dd-MM-yy" />
                              <label>Fecha Inicial</label>
                            </span>
                          </div>
                          <div class="col-12 md:col-6 text-left">
                            <span class="p-float-label">
                              <Calendar v-model="fechaF" dateFormat="dd-MM-yy" />
                              <label>Fecha Final</label>
                            </span>
                          </div>
                        </div>
                    </div>
                    <!-- BOTONES -->
                    <div class="field col-1 text-right">
                        <Button icon="pi pi-plus" class="p-button-rounded p-button-success p-button-outlined mr-1" @click="NuevaNomina"/>
                        <Button icon="pi pi-replay" class="p-button-rounded p-button-info p-button-outlined" @click="GetNomina"/>
                    </div>
                </div>
            </template>
            <Column header="Acciones" :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'min-width': '10rem' }" frozen>
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-info" v-tooltip.bottom="'Ver Nómina'" @click="AbrirNomina(slotProps.data)" />
                    <Button icon="mdi mdi-trash-can" class="p-button-rounded p-button-danger" v-tooltip.bottom="'Eliminar'" @click="OpenDialogDeleteNomina(slotProps.data)" />
                </template>
            </Column>
            <Column field="idNomina" header="ID" :styles="{ 'flex-grow': '1', 'flex-basis': '50px', 'font-size': '90%' }">
            </Column>
            <Column field="serie" header="Serie" :styles="{ 'flex-grow': '1', 'flex-basis': '50px', 'font-size': '90%' }">
            </Column>
            <Column field="descripcion" header="Descripcón" :styles="{ 'flex-grow': '1', 'flex-basis': '50px', 'font-size': '90%' }">
            </Column>
            <Column field="tipoNomina.tipoNomina" header="Tipo Nómina" :styles="{ 'flex-grow': '1', 'flex-basis': '50px', 'font-size': '90%' }">
            </Column>
            <Column field="periodicidadPago.periodicidadPago" header="Periodicidad de Pago" :styles="{ 'flex-grow': '1', 'flex-basis': '50px', 'font-size': '90%' }">
            </Column>
            <Column field="fechaPago" header="Fecha Pago" :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                <template #body="slotProps">
                    <span>{{ formatDate(slotProps.data.fechaPago) }}</span>
                </template>
            </Column>
            <Column field="fechaPago" header="Fecha Inicial" :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                <template #body="slotProps">
                    <span>{{ formatDate(slotProps.data.fechaInicialPago) }}</span>
                </template>
            </Column>
            <Column field="fechaPago" header="Fecha Final" :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                <template #body="slotProps">
                    <span>{{ formatDate(slotProps.data.fechaFinalPago) }}</span>
                </template>
            </Column>
        </DataTable>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import NuevaNomina from './NuevaNomina/Nomina.vue'
    import NominaGuardada from './NominaGuardada/NominaGuardada.vue'

    export default {
        components: {
            NuevaNomina,
            NominaGuardada,
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',

                dialogNuevaNomina: false,
                dialogNominaGuardada: false,

                fechaI: new Date(),
                fechaF: new Date(),
                spinnerT: false,

                timbresDisponibles: '',

                dialogDelete: false,

                selectedNomina: {
                    descripcion: '',
                },
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },

            listaNominas(){
                return this.$store.state.listNominaStore;
            },
        },
        created() {
            this.Iniciales();
        },
        methods: {
            async Iniciales(){
                this.loading = true;
                await this.getTimbres();
                this.loading = false;
            },

            NuevaNomina(){
                this.dialogNuevaNomina = true;
            },

            formatDate(value) {
                moment.locale('es-mx');
                return moment(value).format('DD-MMMM-YYYY')
            },

            async GetNomina(){
                this.loading = true
                this.loadingMensaje = 'Consultando espere...'
                try{
                    let fI = moment(this.fechaI).format('YYYY-MM-DD HH:mm:ss')
                    let fF = moment(this.fechaF).format('YYYY-MM-DD HH:mm:ss')
                    let respuesta = await axios.get("Nomina/GetNominaGeneral/"+ this.token.empresaBase + '/' + fI + '/' + fF);
                    let x =  respuesta.data;
                    this.$store.state.listNominaStore = x
                    this.loading = false;
                    console.log(x)
                }catch(error){
                    this.loading = false;
                    console.log(error)
                }
            },

            async AbrirNomina(item){
                this.loading = true
                this.loadingMensaje = 'Consultando espere...'
                try{
                    let idNomina = item.idNomina;
                    let respuesta = await axios.get("Nomina/GetNominaCompleto/"+ this.token.empresaBase + '/' + idNomina);
                    let x =  respuesta.data;
                    x.fechaPago = this.formatDate(x.fechaPago)
                    console.log(x)
                    this.$store.state.nominaGuardada = item;
                    this.$store.state.listNominaGuardada = x;
                    this.dialogNominaGuardada = true;
                    this.loading = false;
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            async getTimbres() {
                this.spinnerT = true;
                this.loadingMensaje = 'Consultando timbres...'
                try {
                    let response = await axios.get('Comprobantes/GetTimbres/' + this.token.rfc);
                    let timbres_ = response.data
                    this.timbresDisponibles = new Intl.NumberFormat('en-IN').format(timbres_)
                    this.spinnerT = false;
                } catch (error) {
                    console.log(error)
                    this.spinnerT = false;
                }
            },
            
            OpenDialogDeleteNomina(item){
                this.dialogDelete = true;
                this.selectedNomina = item
                console.log(item)
            },

            async DeleteNomina(){
                try{
                    let idNomina = this.selectedNomina.idNomina
                    let response = await axios.put("Nomina/PutEstatusNomina/"+ this.token.empresaBase + '/' + idNomina);
                    console.log(response.data);
                    const index = this.$store.state.listNominaStore.findIndex(item => item.idNomina == idNomina);
                    this.$store.state.listNominaStore.splice(index, 1);
                    this.dialogDelete = false;
                }catch(error){
                    console.log(error);
                }
            },
        
        },
    }
    </script>
    <style>

    </style>